export default __webpack_public_path__ + "static/media/usa.032da852.svg";